import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  userToDelete,
  listTenant,
  updateTenant,
  uploadKYCByUser,
  fetchKYCListByTenant,
  getAdsCount,
  uploadKYCByTenant,
  createTenant,
  listTenantSubAdmin,
  updateTenantSubAdmin,
  createTenantSubAdmin,
  getTenantDetailByID,
  updateTenantPreferences,
  getTenantPreferences,
  getTenantListLite,
  setPaymentConfig,
  getTenantAnalyticReport,
  updateStatus,
  fetchKYCListByUser
} from "../../services/tenant";

@Module({
  namespaced: true
})
export default class Item extends VuexModule {
  // state
  tenantsList = [];
  adsCount = [];
  tenantSubAdminList = [];
  currentTenantAccess = "";
  tenantPreferences = {};
  tenantListLite = [];
  kycUser= [];

  // actions
  @Action
  public async fetchKYCListByUser(payload){
    this.context.commit("setKycByUser", {}); // reset
    try {
     const res = await fetchKYCListByUser(payload.id);
     this.context.commit("setKycByUser", res.data.response);
     return res.data.data;
   } catch (error) {
     throw error;
   }
  }

  @Action
  public async updateStatus(payload){
    try {
     const data = await updateStatus(payload.id,payload.data);
     return data;
   } catch (error) {
     throw error;
   }
  }

  @Action
  public async fetchTenantAnalyticReport(payload){
    try {
     if (Array.isArray(payload)) {
       const responseData = {}
       const allData = payload.map(async (x) => {
         const res = await getTenantAnalyticReport(x.payload);
         responseData[x.key] = res.data.response
         return;
       })
       await Promise.all(allData);
       return responseData;
     }
     const data = await getTenantAnalyticReport(payload);
     return data.data.response;
   } catch (error) {
     throw error;
   }
  }

  @Action
  public async fetchTenantsListLite() {
    try {
      const data = await getTenantListLite();
      this.context.commit("setTenantListLite", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setPaymentConfigAction(payload) {
    try {
      const data = await setPaymentConfig(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantsList() {
    try {
      const data = await listTenant();
      this.context.commit("setTenantList", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateTenantById(payload) {
    try {
      const data = await updateTenant(payload.id, payload.data);
      this.context.dispatch("fetchTenantsList");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getTenantDetailByID(payload) {
    try {
      const data = await getTenantDetailByID(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createTenant(payload) {
    try {
      const data = await createTenant(payload);
      this.context.dispatch("fetchTenantsList");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchAdsCount() {
    try {
      const data = await getAdsCount();
      this.context.commit("getAdsCount", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchKYCListByTenant(Id) {
    try {
      const data = await fetchKYCListByTenant(Id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async submitKYCByTenant(payload) {
    try {
      const data = await uploadKYCByTenant(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantSubAdminList() {
    try {
      const data = await listTenantSubAdmin();
      this.context.commit("setTenantSubAdminList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteUser(payload) {
    try {
      const data = await userToDelete(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createTenantSubAdmin(payload) {
    try {
      const data = await createTenantSubAdmin(payload);
      this.context.dispatch("fetchTenantSubAdminList");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateTenantSubAdminById(payload) {
    try {
      const data = await updateTenantSubAdmin(payload.id, payload.data);
      this.context.dispatch("fetchTenantSubAdminList");
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async submitKYCByUser(payload) {
    try {
      const data = await uploadKYCByUser(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setTenantCatalogAccess(payload) {
    try {
      this.context.commit("setCurrentTenantCatalogAccess", payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateTenantPreferences(payload) {
    try {
      const data = await updateTenantPreferences(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getTenantPreferences(payload) {
    try {
      const data = await getTenantPreferences(payload);
      this.context.commit("setTenantPreference", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations


  @Mutation
  public setKycByUser(data: any) {
    this.kycUser = data;
  }

  @Mutation
  public setTenantList(data: any) {
    this.tenantsList = data;
  }

  @Mutation
  public setTenantListLite(data: any) {
    this.tenantListLite = data;
  }

  @Mutation
  public getAdsCount(data: any) {
    this.adsCount = data;
  }

  @Mutation
  public setTenantSubAdminList(data: any) {
    this.tenantSubAdminList = data;
  }

  @Mutation
  public setCurrentTenantCatalogAccess(data: any) {
    this.currentTenantAccess = data;
  }

  @Mutation
  public setTenantPreference(data: any) {
    this.tenantPreferences = data;
  }

  // getters
  get GetTenantList() {
    return this.tenantsList;
  }

  get GetTenantLiteList() {
    return this.tenantListLite;
  }

  get GetTenantSubAdminList() {
    return this.tenantSubAdminList;
  }

  get GetTenantCatalogAccess() {
    return this.currentTenantAccess;
  }

  get GetTenantLanguage() {
    if (this.tenantPreferences.hasOwnProperty("defaultLanguage")) {
      return this.tenantPreferences["defaultLanguage"];
    } else {
      return "en";
    }
  }

  get GetTenantPreferences() {
    return this.tenantPreferences;
  }

  get GetKycByUser() {
    return this.kycUser;
  }
}
